var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M46.7656 18.8047V24.9297H0.882812V18.8047H46.7656ZM41.2969 10.3281V16.4531H6.46094V0.484375H40.9688V6.71875H14.3359V10.3281H41.2969ZM41.1875 27.3906V40.9531H13.8438V43.4141H42.3906V49.4844H6.07812V35.4297H33.3672V33.2969H6.07812V27.3906H41.1875Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText12);
export default __webpack_public_path__ + "static/media/text12.ec9dbc987e781a6243ec6a6046a83516.svg";
export { ForwardRef as ReactComponent };